<div class="container-fluid">

	<div class="row row-header">
		<div class="col">

			<div class="breadcrumbs"></div>
			<div data-testid="SUBSYS1_LEGALTERMS_LOGO_TXT" class="logo-full-text">{{ labels().APP_LOGO_TEXT }}</div>
			<h1 data-testid="SUBSYS1_LEGALTERMS_TITLE_TXT">{{ labels().LEGAL_TERMS_PAGE_COMPONENT_TITLE }}</h1>

		</div>
	</div>


	<div class="row row-contents">

		<div class="col-2">
			<div class="form-group">
				<label data-testid="SUBSYS1_LEGALTERMS_COUNTRY_LBL" for="country">
					{{ labels().LEGAL_TERMS_PAGE_COMPONENT_COUNTRY }}
				</label>
				<select data-testid="SUBSYS1_LEGALTERMS_COUNTRY_SELECT" class="form-control custom-select" id="country"
					autocomplete="off" [(ngModel)]="countryCode" (change)="updateDocuments()">
					@for (country of countryList; track country.code) {
					<option [attr.data-testid]="'SUBSYS1_LEGALTERMS_COUNTRY_OPTION_' + (country.code)" [ngValue]="country.code">
						{{ country.name }}
					</option>
					}
				</select>
			</div>
		</div>

		@if (docList.length === 3) {

		<div class="col-11">
			<div class="legal-swiper">
				<h3 data-testid="SUBSYS1_LEGALTERMS_EULA_TITLE_TXT">{{ labels().LEGAL_TERMS_PAGE_COMPONENT_EULA }}</h3>
				<div data-testid="SUBSYS1_LEGALTERMS_EULA_BOX" class="swiper-slide-content" [innerHTML]="eulaText"></div>
			</div>
		</div>

		<div class="col-11">
			<div class="legal-swiper">
				<h3 data-testid="SUBSYS1_LEGALTERMS_PRIVACY_TITLE_TXT">{{ labels().LEGAL_TERMS_PAGE_COMPONENT_PRIVACY_POLICY }}
				</h3>
				<div data-testid="SUBSYS1_LEGALTERMS_PRIVACY_BOX" class="swiper-slide-content" [innerHTML]="privacyPolicyText">
				</div>
			</div>
		</div>

		<div class="col-11">
			<div class="legal-swiper">
				<h3 data-testid="SUBSYS1_LEGALTERMS_DPA_TITLE_TXT">{{ labels().LEGAL_TERMS_PAGE_COMPONENT_DPA }}</h3>
				<div data-testid="SUBSYS1_LEGALTERMS_DPA_BOX" class="swiper-slide-content" [innerHTML]="dpaText"></div>
			</div>
		</div>

		}

		@if (docList && docList.length === 0) {

		<div class="col-11">
			<p data-testid="SUBSYS1_LEGALTERMS_EMPTY_TXT" class="invalid-feedback d-block">
				{{ labels().LEGAL_TERMS_PAGE_COMPONENT_NO_DOCUMENTS }}
			</p>
		</div>

		}

	</div>

</div>